import React, { Component } from 'react';

import { computeUpgrade } from '../details/UpgradePrompt';

// Paid-plan reminder shown once, when the user progresses from
// Configure to the License Key step with paid properties selected.
// Lists the paid properties, names the lowest plan that covers the
// whole selection with its monthly requests and price, and offers to
// continue or go back and review. Focus moves into the dialog while
// it is open and stays there; Escape and the backdrop go back.
export class PlanPrompt extends Component {
    displayName = PlanPrompt.name;

    constructor(props) {
        super(props);
        this.cardRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (this.props.properties && !prevProps.properties &&
            this.cardRef.current) {
            var first = this.cardRef.current.querySelector('button');
            if (first) {
                first.focus();
            }
        }
    }

    onKeyDown = (e) => {
        if (e.key === 'Escape') {
            this.props.onBack();
            return;
        }
        if (e.key === 'Tab' && this.cardRef.current) {
            var focusables = this.cardRef.current
                .querySelectorAll('a[href], button');
            if (focusables.length === 0) {
                return;
            }
            var first = focusables[0];
            var last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }

    onBackdrop = (e) => {
        if (e.target === e.currentTarget) {
            this.props.onBack();
        }
    }

    render() {
        const properties = this.props.properties;
        if (!properties || properties.length === 0) {
            return null;
        }

        const shown = properties.slice(0, 6);
        const extra = properties.length - shown.length;

        const upgrade = computeUpgrade(
            this.props.plans, this.props.selectedProperties, []);
        const required = upgrade ? upgrade.required : null;

        return (
            <div className="c-plan-prompt" role="dialog" aria-modal="true"
                aria-labelledby="planPromptHeading"
                onKeyDown={this.onKeyDown}
                onClick={this.onBackdrop}>
                <article className="c-card c-plan-prompt__card"
                    ref={this.cardRef}>
                    <header className="c-card__header">
                        <h3 className="c-card__heading" id="planPromptHeading">
                            You have selected properties requiring a paid plan
                        </h3>
                    </header>
                    <ul className="c-plan-prompt__list">
                        {shown.map((p, i) => (
                            <li key={i}>
                                <strong>{p.Name}</strong>
                                {' '}({p.Plans && p.Plans.length > 0 ?
                                    p.Plans.join(', ') : 'Bespoke'})
                            </li>
                        ))}
                        {extra > 0 ? (
                            <li>and {extra} more</li>
                        ) : null}
                    </ul>
                    {required ? (
                        <p>
                            The lowest plan covering your selected
                            properties is <strong>{required.Name}</strong>
                            {required.RequestsPerMonth > 0 ?
                                <span>
                                    {' '}({required.RequestsPerMonth.toLocaleString()}
                                    {' '}requests per month
                                    {required.PricePerMonth > 0 ?
                                        <span> at &euro;{required.PricePerMonth}/month</span>
                                        : null})
                                </span>
                                : null}.
                            To compare plans, go to our{' '}
                            <a href="https://51degrees.com/pricing"
                                target="_blank" rel="noopener noreferrer">
                                pricing page</a>.
                        </p>
                    ) : null}
                    <div className="c-plan-prompt__actions">
                        <button type="button" className="b-btn"
                            onClick={this.props.onContinue}>
                            Continue
                        </button>
                        <button type="button"
                            className="b-btn b-btn--secondary"
                            onClick={this.props.onBack}>
                            Review my selection
                        </button>
                    </div>
                </article>
            </div>
        );
    }
}
